<div class="flex min-h-dvh flex-col bg-ground">
  <layout-header />

  <main class="flex-1">
    <router-outlet></router-outlet>
  </main>

  <layout-footer />

  <layout-language-suggestion />
</div>
